/**
 * Beside groups, the channels in none sit under this heading, in the table and the navigation alike: "Channels" would
 * repeat the page's own name over only some of them. A pure module, so the marketing site's product shots draw it too.
 */
export const UNGROUPED_CHANNELS_LABEL = "Other channels";
